import { Fragment } from 'react';
import { Avatar, Text, PlaceholderParagraph } from '@innovaccer/design-system';
import { formatDate } from '../../../utils/utils';

const getReportStatusAppearance = (status) => {
  switch (status) {
    case 'SUCCESS':
      return 'success';
    case 'FAILURE':
      return 'alert';
    case 'In Progress':
      return 'info';
    default:
      return '';
  }
};
const getReportStatusText = (status) => {
  switch (status) {
    case 'SUCCESS':
      return 'Completed';
    case 'FAILURE':
      return 'Failed';
    case 'In Progress':
      return 'In progress';
  }
};

export const schema = [
  {
    name: 'version_id',
    displayName: 'Version tag',
    width: '30%',
    showMenu: false,
    cellRenderer: (props) => {
      const { version_id } = props.data;
      return (
        <Fragment>
          {props.loading ? <PlaceholderParagraph length="medium" /> : <Text>Standard-etl-{version_id}</Text>}
        </Fragment>
      );
    }
  },
  {
    name: 'timestamp',
    displayName: 'Timestamp',
    width: '25%',
    sorting: false,
    showMenu: false,
    cellRenderer: (props) => {
      const { timestamp } = props.data;
      return (
        <Fragment>
          {props.loading ? <PlaceholderParagraph length="medium" /> : <Text>{formatDate(timestamp)}</Text>}
        </Fragment>
      );
    }
  },
  {
    name: 'status',
    displayName: 'Status',
    width: '25%',
    resizable: true,
    align: 'start',
    cellType: 'STATUS_HINT',
    sorting: false,
    translate: (a) => ({
      title: getReportStatusText(a.status),
      statusAppearance: getReportStatusAppearance(a.status)
    })
  },
  {
    name: 'customCell',
    displayName: '',
    width: '15%',
    cellType: 'WITH_META_LIST',
    sorting: false,
    showMenu: false,
    cellRenderer: (props) => {
      const { userDetails = ',' } = props.data;
      const [lastName, firstName] = userDetails.split(',');
      return (
        <div className="w-100 mr-6 d-flex justify-content-end">
          {props.loading ? (
            <PlaceholderParagraph length="medium" />
          ) : (
            <Avatar lastName={lastName} firstName={firstName} />
          )}
        </div>
      );
    }
  }
];
